// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"844":"23594532bce4effc","895":"bde01f7d76df312a","6321":"5545372441e05d2e"}[chunkId] + ".css";
};